<!-- navbar.component.html -->
<nav class="navbar navbar-expand-lg navbar-dark fixed-top" [class.navbar-scrolled]="isScrolled">
  <div class="container">
    <img
      src="assets/logo1.png"
      srcset="assets/logo1-2x.png 2x, assets/logo1-3x.png 3x"
      alt="Logo"
      id="imgnav"
      class="d-inline-block align-text-top"
    />

    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav ms-auto">
        <li class="nav-item">
          <a class="nav-link nav-link-custom" routerLink="/" routerLinkActive="active">
            <i class="bi bi-house-door me-2"></i> Inicio
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link nav-link-custom"
            [routerLink]="['/']"
            fragment="historia"
            routerLinkActive="active"
          >
            <i class="bi bi-people me-2"></i> Nosotros
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link nav-link-custom" routerLink="/producto" routerLinkActive="active">
            <i class="bi bi-box-seam me-2"></i> Productos
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link nav-link-custom" routerLink="/contacto" routerLinkActive="active">
            <i class="bi bi-envelope me-2"></i> Contacto
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link nav-link-custom" routerLink="/login" routerLinkActive="active">
            <i class="bi bi-box-arrow-in-right me-2"></i> Login
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
